export function createSectionMap(elements) {
    const map = new Map();

    elements.forEach((element) => {
        if (!(element instanceof HTMLElement)) {
            return;
        }

        const statusValue = String(element.dataset.status ?? '').trim();
        if (statusValue === '' || map.has(statusValue)) {
            return;
        }

        map.set(statusValue, element);
    });

    return map;
}
